<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">
        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="accesstypes" id="access" formControlName="access" optionLabel="name"
              optionValue="value" placeholder="Access" pTooltip="Access all users or only current user."
            tooltipPosition="bottom"></p-dropdown>
            <label for="access">Access</label>
            @for (validation of validationMessages.access; track validation) {
              <span>
                @if (form1.get('access').hasError(validation.type) && (form1.get('access').dirty || form1.get('access').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText pTooltip="Name of the inbox."
              tooltipPosition="bottom">
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="email" id="email" type="text" pInputText pTooltip="Mail address for which user wants to access inbox."
              tooltipPosition="bottom">
            <label for="email">email</label>
            @for (validation of validationMessages.email; track validation) {
              <span>
                @if (form1.get('email').hasError(validation.type) && (form1.get('email').dirty || form1.get('email').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="password" id="password" type="password" pInputText pTooltip="Password of email address for authentication."
              tooltipPosition="bottom">
            <label for="password">password</label>
            @for (validation of validationMessages.password; track validation) {
              <span>
                @if (form1.get('password').hasError(validation.type) && (form1.get('password').dirty || form1.get('password').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="protocol" id="protocol" formControlName="protocol" optionLabel="name"
              optionValue="value" placeholder="Protocol" pTooltip="Mail protocol"
            tooltipPosition="bottom"></p-dropdown>
            <label for="protocol">protocol</label>
            @for (validation of validationMessages.protocol; track validation) {
              <span>
                @if (form1.get('protocol').hasError(validation.type) && (form1.get('protocol').dirty || form1.get('protocol').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="host" id="host" type="text" pInputText pTooltip="Mail server host name."
              tooltipPosition="bottom">
            <label for="host">host</label>
            @for (validation of validationMessages.host; track validation) {
              <span>
                @if (form1.get('host').hasError(validation.type) && (form1.get('host').dirty || form1.get('host').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="port" id="port" type="text" pInputText pTooltip="Mail server port."
              tooltipPosition="bottom">
            <label for="port">port</label>
            @for (validation of validationMessages.port; track validation) {
              <span>
                @if (form1.get('port').hasError(validation.type) && (form1.get('port').dirty || form1.get('port').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastreaduid" id="lastreaduid" type="text" pInputText pTooltip="From which count user wants to fetch inbox mail."
              tooltipPosition="bottom">
            <label for="lastreaduid">last read uid(Mail read will start from this UID)</label>
            @for (validation of validationMessages.lastreaduid; track validation) {
              <span>
                @if (form1.get('lastreaduid').hasError(validation.type) && (form1.get('lastreaduid').dirty || form1.get('lastreaduid').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastsentreaduid" id="lastsentreaduid" type="text" pInputText pTooltip="From which count user wants to fetch sent mail."
              tooltipPosition="bottom">
            <label for="lastsentreaduid">last read uid For Sent Box(Mail read will start from this UID)</label>
            @for (validation of validationMessages.lastsentreaduid; track validation) {
              <span>
                @if (form1.get('lastsentreaduid').hasError(validation.type) && (form1.get('lastsentreaduid').dirty || form1.get('lastsentreaduid').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="msgreadpercall" id="msgreadpercall" type="text" pInputText pTooltip="Howmany mail can be fetch at a time."
              tooltipPosition="bottom">
            <label for="msgreadpercall">msg read per call(every time job execution will download these many mails)</label>
            @for (validation of validationMessages.msgreadpercall; track validation) {
              <span>
                @if (form1.get('msgreadpercall').hasError(validation.type) && (form1.get('msgreadpercall').dirty || form1.get('msgreadpercall').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="msgremainingToBeRead" id="msgremainingToBeRead" type="text" pInputText pTooltip="Mail server msgremainingToBeRead."
              tooltipPosition="bottom">
            <label for="msgremainingToBeRead">msg remaining To Be Read</label>
            @for (validation of validationMessages.msgremainingToBeRead; track validation) {
              <span>
                @if (form1.get('msgremainingToBeRead').hasError(validation.type) && (form1.get('msgremainingToBeRead').dirty || form1.get('msgremainingToBeRead').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <app-user-search (onUserSelected)="onUserSeleted($event)" [selectedUser]="selectedUser"></app-user-search>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="inboxFolder" id="inboxFolder" type="text" pInputText pTooltip="Name of received mail folder."
              tooltipPosition="bottom">
            <label for="inboxFolder">inbox Folder name</label>
            @for (validation of validationMessages.inboxFolder; track validation) {
              <span>
                @if (form1.get('inboxFolder').hasError(validation.type) && (form1.get('inboxFolder').dirty || form1.get('inboxFolder').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="sentFolder" id="sentFolder" type="text" pInputText pTooltip="Name of sent mail folder."
              tooltipPosition="bottom">
            <label for="sentFolder">Sent Folder Name</label>
            @for (validation of validationMessages.sentFolder; track validation) {
              <span>
                @if (form1.get('sentFolder').hasError(validation.type) && (form1.get('sentFolder').dirty || form1.get('sentFolder').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>




        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="smtpProtocol" id="smtpProtocol" type="text" pInputText pTooltip="Mail server smtpProtocol."
              tooltipPosition="bottom" value="SMTP" disabled="disabled">
            <label for="smtpProtocol">SMTP Protocol</label>
            @for (validation of validationMessages.smtpProtocol; track validation) {
              <span>
                @if (form1.get('smtpProtocol').hasError(validation.type) && (form1.get('smtpProtocol').dirty || form1.get('smtpProtocol').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="smtpHost" id="smtpHost" type="text" pInputText pTooltip="Mail server smtpHost"
              tooltipPosition="bottom">
            <label for="smtpHost">SMTP Host</label>
            @for (validation of validationMessages.smtpHost; track validation) {
              <span>
                @if (form1.get('smtpHost').hasError(validation.type) && (form1.get('smtpHost').dirty || form1.get('smtpHost').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="smtpPort" id="smtpPort" type="text" pInputText pTooltip="Mail server smtpPort."
              tooltipPosition="bottom">
            <label for="smtpPort">SMTP Port</label>
            @for (validation of validationMessages.smtpPort; track validation) {
              <span>
                @if (form1.get('smtpPort').hasError(validation.type) && (form1.get('smtpPort').dirty || form1.get('smtpPort').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="smtpSSLPort" id="smtpSSLPort" type="text" pInputText pTooltip="Mail server smtpSSLPort."
              tooltipPosition="bottom">
            <label for="smtpSSLPort">SMTP SSL Port</label>
            @for (validation of validationMessages.smtpSSLPort; track validation) {
              <span>
                @if (form1.get('smtpSSLPort').hasError(validation.type) && (form1.get('smtpSSLPort').dirty || form1.get('smtpSSLPort').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['active']" inputId="active" [binary]="true"></p-checkbox>
            <span class="imapConfiguration-nm">Enable IMAP Mail Download?</span>
            <span class="ml-5">   <a href="https://myaccount.google.com/lesssecureapps" target="_blank">enable less secure app access for Gmail Account</a></span>
            <span class="ml-5">   <a href="https://myaccount.google.com/apppasswords" target="_blank">Create App Password</a></span>
          </div>
          @for (validation of validationMessages.active; track validation) {
            <span>
              @if (form1.get('active').hasError(validation.type) && (form1.get('active').dirty || form1.get('active').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>

      </div>

      <!-- ============================================================ -->
      <!-- Gmail API Settings Section                                    -->
      <!-- ============================================================ -->
      <div class="row m-0 mt-4">
        <div class="col-lg-12">
          <h4 style="border-bottom: 1px solid #ccc; padding-bottom: 8px; margin-bottom: 16px;">Gmail API Settings</h4>
        </div>

        <div class="col-lg-12">
          <div class="flex align-items-center mb-3">
            <p-checkbox [formControl]="form1.controls['gmailSyncEnabled']" inputId="gmailSyncEnabled" [binary]="true"></p-checkbox>
            <span class="ml-2">Enable Gmail API Sync</span>
          </div>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="gmailAuthTypes" id="gmailAuthType" formControlName="gmailAuthType" optionLabel="name"
              optionValue="value" placeholder="Auth Type" pTooltip="Gmail API authentication method."
              tooltipPosition="bottom"></p-dropdown>
            <label for="gmailAuthType">Auth Type</label>
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="gmailCredentials" id="gmailCredentials" pInputTextarea rows="4"
              pTooltip="Service Account JSON key, OAuth2 JSON ({client_id, client_secret, refresh_token}), or access token."
              tooltipPosition="bottom" style="width:100%;font-family:monospace;font-size:12px;"></textarea>
            <label for="gmailCredentials">Gmail Credentials</label>
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="gmailHistoryId" id="gmailHistoryId" type="text" pInputText
              pTooltip="Gmail history ID watermark for incremental sync. Leave empty for fresh sync."
              tooltipPosition="bottom">
            <label for="gmailHistoryId">Gmail History ID</label>
          </span>
        </div>

        <div class="col-lg-6 d-flex align-items-center mb-3">
          <button pButton class="p-button-outlined p-button-info" (click)="testGmailConnection()" [loading]="gmailTestLoading"
            pTooltip="Test Gmail API connection with the configured credentials." tooltipPosition="bottom">
            <i class="pi pi-bolt mr-2"></i> Test Gmail Connection
          </button>
        </div>

        @if (gmailTestResult) {
          <div class="col-lg-12 mb-3">
            <div [ngStyle]="{'background-color': gmailTestResult.success ? '#e8f5e9' : '#ffebee', 'padding': '10px', 'border-radius': '4px'}">
              @if (gmailTestResult.success) {
                <p><b>Connected:</b> {{gmailTestResult.emailAddress}}</p>
                <p>Total Messages: {{gmailTestResult.messagesTotal}} | Threads: {{gmailTestResult.threadsTotal}} | Auth: {{gmailTestResult.authTypeName}}</p>
              } @else {
                <p style="color:red;"><b>Failed:</b> {{gmailTestResult.error}}</p>
              }
            </div>
          </div>
        }
      </div>

      <!-- ============================================================ -->
      <!-- Sync Single Gmail Message                                     -->
      <!-- ============================================================ -->
      @if (imapConfigurationId) {
        <div class="row m-0 mt-3">
          <div class="col-lg-12">
            <h4 style="border-bottom: 1px solid #ccc; padding-bottom: 8px; margin-bottom: 16px;">Sync Single Gmail Message</h4>
          </div>
          <div class="col-lg-8">
            <span class="p-float-label w-100 mb-3">
              <input [(ngModel)]="syncGmailMsgId" [ngModelOptions]="{standalone: true}" id="syncGmailMsgId" type="text" pInputText
                pTooltip="Enter the Gmail unique message ID to sync a single email."
                tooltipPosition="bottom">
              <label for="syncGmailMsgId">Gmail Message ID</label>
            </span>
          </div>
          <div class="col-lg-4 d-flex align-items-center mb-3">
            <button pButton class="p-button-outlined p-button-warning" (click)="syncByGmailId()" [loading]="syncGmailLoading">
              <i class="pi pi-download mr-2"></i> Sync Message
            </button>
          </div>

          @if (syncGmailResult) {
            <div class="col-lg-12 mb-3">
              <div [ngStyle]="{'background-color': syncGmailResult.success ? '#e8f5e9' : '#ffebee', 'padding': '10px', 'border-radius': '4px'}">
                @if (syncGmailResult.success) {
                  <p><b>Synced:</b> {{syncGmailResult.subject}}</p>
                  <p>From: {{syncGmailResult.from}} | Date: {{syncGmailResult.date}} | Thread: {{syncGmailResult.threadId}}</p>
                } @else {
                  <p style="color:red;"><b>Failed:</b> {{syncGmailResult.error}}</p>
                }
              </div>
            </div>
          }
        </div>
      }

      <!-- ============================================================ -->
      <!-- Bulk Sync Progress (read-only)                                -->
      <!-- ============================================================ -->
      @if (imapConfigurationId && form1.get('gmailBulkSyncStatus')?.value) {
        <div class="row m-0 mt-3">
          <div class="col-lg-12">
            <h4 style="border-bottom: 1px solid #ccc; padding-bottom: 8px; margin-bottom: 16px;">Bulk Sync Progress</h4>
          </div>
          <div class="col-lg-4">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="gmailBulkSyncStatus" id="gmailBulkSyncStatus" type="text" pInputText>
              <label for="gmailBulkSyncStatus">Status</label>
            </span>
          </div>
          <div class="col-lg-4">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="gmailBulkSyncTotalListed" id="gmailBulkSyncTotalListed" type="text" pInputText>
              <label for="gmailBulkSyncTotalListed">Total Listed</label>
            </span>
          </div>
          <div class="col-lg-4">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="gmailBulkSyncTotalProcessed" id="gmailBulkSyncTotalProcessed" type="text" pInputText>
              <label for="gmailBulkSyncTotalProcessed">Total Processed</label>
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="gmailBulkSyncStartedAt" id="gmailBulkSyncStartedAt" type="text" pInputText>
              <label for="gmailBulkSyncStartedAt">Started At</label>
            </span>
          </div>
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <input formControlName="gmailBulkSyncLastActivityAt" id="gmailBulkSyncLastActivityAt" type="text" pInputText>
              <label for="gmailBulkSyncLastActivityAt">Last Activity</label>
            </span>
          </div>
        </div>
      }

    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (imapConfigurationId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }


            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              <button pButton class="btn-cancel p-button-text" (click)="testConnection()">Test IMAP</button>
              @if (!imapConfigurationId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (imapConfigurationId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
